import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["renderAs", "iconBefore", "iconAfter"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import styled from "styled-components";
import { SearchableSelectLink } from "@interdependence-ui";
import { focusStyle, hoverStyle, addIcon } from "@mixins";
import { SecondaryButtonLink } from "@base-ui";
import { jsx as _jsx } from "react/jsx-runtime";
export var headerHeight = "54px";
var commonNavStyles = function commonNavStyles(theme) {
  return "\n  transition: all .3s;\n  text-decoration: none;\n  display: inline-flex;\n  border-radius: 0;\n  box-shadow: none;\n  font-family: ".concat(theme.fonts.robotoRegular, ";\n  &:hover{ ").concat(hoverStyle(theme), "}\n  &:focus{ ").concat(focusStyle(theme), "}\n");
};
var subNavigationStyles = function subNavigationStyles(theme) {
  return "\n  ".concat(commonNavStyles(theme), "\n  width: 100%;\n  font-size: 1.6rem;\n  padding: 0 2rem;\n  justify-content: left;\n  color: ").concat(theme.colors.P1, ";\n  height: 46px;\n  line-height: 46px;");
};
var NavigationStyles = function NavigationStyles(theme) {
  return "\n  ".concat(commonNavStyles(theme), "\n  width: fit-content;\n  background: ").concat(theme.colors.P1, ";\n  color: ").concat(theme.colors.G1, ";\n  font-size: 1.4rem;\n  padding: 0 2rem;\n  height: ").concat(headerHeight, ";\n  line-height: ").concat(headerHeight, ";\n");
};

//We want the links to mainSite + eternal to live outside of react-router
export var MainSiteNavButton = styled.a.withConfig({
  displayName: "headerstyles__MainSiteNavButton",
  componentId: "sc-l816eo-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    ".concat(NavigationStyles(theme), "\n  ");
});
export var MainSiteSubNavButton = styled.a.withConfig({
  displayName: "headerstyles__MainSiteSubNavButton",
  componentId: "sc-l816eo-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return "\n    ".concat(subNavigationStyles(theme), "\n    background: ").concat(theme.colors.P1, ";\n    color: ").concat(theme.colors.G1, ";\n    border-bottom: 1px solid ").concat(theme.colors.i1, ";\n");
});
export var ExternalSubNavButton = styled.a.withConfig({
  displayName: "headerstyles__ExternalSubNavButton",
  componentId: "sc-l816eo-2"
})(["&:after{", "}", ""], function (_ref3) {
  var theme = _ref3.theme,
    iconAfter = _ref3.iconAfter;
  return iconAfter ? addIcon(theme, iconAfter, "auto 0 auto auto") : "";
}, function (_ref4) {
  var theme = _ref4.theme;
  return "\n    ".concat(subNavigationStyles(theme), "\n    border-bottom: 1px solid ").concat(theme.colors.i1, ";\n");
});

//All Normal navigations go through react-router
export var SubNavButton = styled( /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var renderAs = _ref5.renderAs,
    iconBefore = _ref5.iconBefore,
    iconAfter = _ref5.iconAfter,
    rest = _objectWithoutProperties(_ref5, _excluded);
  return /*#__PURE__*/_jsx(SecondaryButtonLink, _objectSpread(_objectSpread({}, rest), {}, {
    renderAs: renderAs,
    iconBefore: iconBefore || "null",
    iconAfter: iconAfter || "null",
    ref: ref
  }));
})).withConfig({
  displayName: "headerstyles__SubNavButton",
  componentId: "sc-l816eo-3"
})(["", ""], function (_ref6) {
  var theme = _ref6.theme;
  return "\n    ".concat(subNavigationStyles(theme), "\n    border-bottom: 1px solid ").concat(theme.colors.i1, ";\n    &.no-border{\n      border: none;\n    }\n    &:after{\n      margin: 0 0 0 auto;\n    }\n  ");
});
export var MenuToggleButton = styled.a.withConfig({
  displayName: "headerstyles__MenuToggleButton",
  componentId: "sc-l816eo-4"
})(["&:after{", "}", ""], function (_ref7) {
  var theme = _ref7.theme,
    iconAfter = _ref7.iconAfter;
  return iconAfter ? addIcon(theme, iconAfter, "auto 0 auto 10px") : "";
}, function (_ref8) {
  var theme = _ref8.theme;
  return "\n    ".concat(NavigationStyles(theme), "\n  ");
});
export var MeasuresSearch = styled(function (props) {
  return /*#__PURE__*/_jsx(SearchableSelectLink, _objectSpread({}, props));
}).withConfig({
  displayName: "headerstyles__MeasuresSearch",
  componentId: "sc-l816eo-5"
})(["", ""], function (_ref9) {
  var theme = _ref9.theme;
  return "\n    opacity: 0;\n    visibility: hidden;\n    padding: 0 20px;\n    height: 0;\n    background: ".concat(theme.colors.P1, ";\n    transition: all 0.2s ease-in-out;\n    transition-property: height, padding;\n\n    &.open{\n      opacity: 1;\n      visibility: visible;\n      border-top: 1px solid ").concat(theme.colors.i1, ";\n      height: 64px;\n      padding: 10px 20px;\n    }\n  ");
});
export var NavWrapper = styled.div.withConfig({
  displayName: "headerstyles__NavWrapper",
  componentId: "sc-l816eo-6"
})(["", ""], function (_ref10) {
  var theme = _ref10.theme,
    zIndex = _ref10.zIndex;
  return "\n    background: ".concat(theme.colors.G1, ";\n    top: 0;\n    bottom: 0;\n    z-index: ").concat(zIndex, ";\n    right: -400px;\n    max-width: 400px;\n    width: 100%;\n    transition: all 0.3s ease-in-out;\n    transition-property: visibility, right;\n    position: fixed;\n    padding: 10px 20px;\n    border-left: 1px solid ").concat(theme.colors.i1, ";\n    visibility: hidden;\n\n    &.open{\n      overflow-y: auto;\n      overflow-x: hidden;\n      visibility: visible;\n      right: 0;\n    }\n  ");
});